<template>
  <!-- 图片与视频 -->
  <div class="topImage" id="preferredBrand-banner">
    <div class="imgArea" v-show="(!dataSource.videoUrl || !isPlayVideo) &&dataSource.imageUrl">
      <el-image
        :fit="'contain'"
        id="specialActivity-banner"
        class="bannerImg"
        :src="dataSource.imageUrl"
        alt="banner"
      />
      <img
        v-if="dataSource.videoUrl"
        @click="onPlay"
        src="~@/assets/img/preferredBrand/play_icon.svg"
        class="playIcon"
      />
    </div>
    <div class="video-container" v-show="isPlayVideo">
      <video
        width="100%"
        id="topVideo"
        controls
        oncontextmenu="return false"
        controlsList="nodownload"
        :autoplay="false"
        preload="auto"
        :src="dataSource.videoUrl"
      ></video>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isPlayVideo: false,
    };
  },
  methods: {
    onPlay() {
      this.isPlayVideo = true;
      const dom = document.getElementById("topVideo");
      if (dom) {
        dom.play();
      }
    },
    onStop() {
      this.isPlayVideo = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.topImage {
  .bannerImg {
    width: 100%;
    object-fit: contain;
  }
  .imgArea {
    position: relative;
  }
  .playIcon {
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .video-container {
    position: relative;
    padding-top: 56.25%; /* 16:9 比例 (9 ÷ 16 = 0.5625) */
    height: 0;
    overflow: hidden;
    background: #000;
  }

  .video-container video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    aspect-ratio: 16 / 9;
  }
}
</style>
